const ASSETS = [
  {
    id: 'bedrockTexture',
    path: ['/assets/textures/blocks/bedrock/bedrock_3.png'],
    type: 'texture',
  },
  {
    id: 'grassTexture',
    path: ['/assets/textures/blocks/grass/grass.png'],
    type: 'texture',
  },
  {
    id: 'grassSideTexture',
    path: ['/assets/textures/blocks/grass/grass_side.png'],
    type: 'texture',
  },
  {
    id: 'grassVariationTexture',
    path: ['/assets/textures/blocks/grass/grass_variation.png'],
    type: 'texture',
  },
  {
    id: 'winterGrassTexture',
    path: ['/assets/textures/blocks/grass/winter_grass.png'],
    type: 'texture',
  },
  {
    id: 'winterGrassSideTexture',
    path: ['/assets/textures/blocks/grass/winter_grass_side.png'],
    type: 'texture',
  },
  {
    id: 'autumnGrassTexture',
    path: ['/assets/textures/blocks/grass/autumn_grass.png'],
    type: 'texture',
  },
  {
    id: 'autumnGrassSideTexture',
    path: ['/assets/textures/blocks/grass/autumn_grass_side.png'],
    type: 'texture',
  },
  {
    id: 'autumnGrassVariationTexture',
    path: ['/assets/textures/blocks/grass/autumn_grass_variation.png'],
    type: 'texture',
  },
  {
    id: 'dirtTexture',
    path: ['/assets/textures/blocks/dirt/dirt.png'],
    type: 'texture',
  },
  {
    id: 'stoneTexture',
    path: ['/assets/textures/blocks/stone/stone.png'],
    type: 'texture',
  },
  {
    id: 'coalOreTexture',
    path: ['/assets/textures/blocks/coal/coal_ore.png'],
    type: 'texture',
  },
  {
    id: 'ironOreTexture',
    path: ['/assets/textures/blocks/iron/iron_ore.png'],
    type: 'texture',
  },
  {
    id: 'goldOreTexture',
    path: ['/assets/textures/blocks/gold/gold_ore.png'],
    type: 'texture',
  },
  {
    id: 'treeTopTexture',
    path: ['/assets/textures/blocks/tree/jungle_log_top_1.png'],
    type: 'texture',
  },
  {
    id: 'treeSideTexture',
    path: ['/assets/textures/blocks/tree/jungle_log_1.png'],
    type: 'texture',
  },
  {
    id: 'sandTexture',
    path: ['/assets/textures/blocks/sand/sand_1.png'],
    type: 'texture',
  },
  {
    id: 'leavesTexture',
    path: ['/assets/textures/blocks/leaves/leaves.png'],
    type: 'texture',
  },
  {
    id: 'leavesVariationTexture',
    path: ['/assets/textures/blocks/leaves/leaves_variation.png'],
    type: 'texture',
  },
  {
    id: 'autumnLeavesTexture',
    path: ['/assets/textures/blocks/leaves/autumn_leaves.png'],
    type: 'texture',
  },
  {
    id: 'autumnLeavesVariationTexture',
    path: ['/assets/textures/blocks/leaves/autumn_leaves_variation.png'],
    type: 'texture',
  },
  {
    id: 'winterLeavesTexture',
    path: ['/assets/textures/blocks/leaves/winter_leaves.png'],
    type: 'texture',
  },
  {
    id: 'winterLeavesVariationTexture',
    path: ['/assets/textures/blocks/leaves/winter_leaves.png'],
    type: 'texture',
  },
  {
    id: 'cloudTexture',
    path: ['/assets/textures/blocks/cloud/cloud.png'],
    type: 'texture',
  },
  {
    id: 'bubbleTexture',
    path: ['/assets/textures/water/bubble.png'],
    type: 'texture',
  },
  {
    id: 'waterDiffuseTexture',
    path: ['/assets/textures/water/diffuse.png'],
    type: 'texture',
  },
  {
    id: 'bushTexture',
    path: ['/assets/textures/bush/bush.png'],
    type: 'texture',
  },
];

export default ASSETS;
